import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { RudderAnalytics } from "@temp/app/analitics";
import { useSignOut } from "@sdk/react";
import * as S from "./styles";
export var AccountMenu = function AccountMenu(_ref) {
  var links = _ref.links,
      active = _ref.active;

  var _useSignOut = useSignOut(),
      _useSignOut2 = _slicedToArray(_useSignOut, 1),
      signOut = _useSignOut2[0];

  var intl = useIntl();

  var handleSignOut = function handleSignOut() {
    // @analitics
    RudderAnalytics.identify("", {
      isLoggedIn: false
    });
    signOut();
  };

  return React.createElement(S.Wrapper, null, React.createElement(S.MenuItems, null, links.map(function (link) {
    return React.createElement(Link, {
      to: link.url,
      key: link.url,
      "data-testid": "account_menu__link"
    }, React.createElement(S.MenuItem, {
      active: active === link.url
    }, link.label));
  })), React.createElement("span", {
    onClick: handleSignOut,
    "data-testid": "account_menu__link"
  }, React.createElement(S.MenuItemLogOut, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Log out",
    "id": "@next.components.molecules.AccountMenu.AccountMenu.21332146"
  }, "id", "@next.components.molecules.AccountMenu.AccountMenu.21332146")))));
};